<template>
  <div>
    <span id="loading" v-if="this.loading == true">
      <Loading />
    </span>
    <h3 class="container mt-4" style="text-align: center">Import Files</h3>
    <div class="container mt-5">
      <div class="d-flex">
        <select
          class="form-select"
          aria-label="Default select example"
          v-model="typeImport"
        >
          <option value="" disabled selected>Select type import</option>
          <option value="prices">Product Price</option>
          <option value="names">Product Name</option>
          <!-- 1. ADICIONADO: Nova opção no Select -->
          <option value="hscodes">Product HS Code</option>
        </select>
      </div>
    </div>
    <div class="container mt-2">
      <div class="d-flex">
        <div class="custom-file mr-2">
          <input
            type="file"
            class="custom-file-input"
            id="customFile"
            ref="file"
            @change="onFileChange"
            accept=".csv"
          />
          <label class="custom-file-label" for="customFile">{{
            fileName
          }}</label>

          <small v-if="typeImport == 'prices'">
            <i class="fas fa-info"></i>Download the
            <a class="template" @click="downloadTemplate">template</a> (format
            "final_date" yyyy-mm-dd or empty if dont have deadline | use dot (.)
            not comma(,))
          </small>
          <small v-else-if="typeImport == 'names'">
            <i class="fas fa-info" style="margin: 0px 5px"></i>Download the
            <a class="template" @click="downloadTemplate">template</a>
          </small>
          <!-- 2. ADICIONADO: Texto de ajuda para o HS Code -->
          <small v-else-if="typeImport == 'hscodes'">
            <i class="fas fa-info" style="margin: 0px 5px"></i>Download the
            <a class="template" @click="downloadTemplate">template</a> (format:
            id_backoffice, hscode)
          </small>
        </div>
        <button class="btn btn-primary" @click="sendFile">Import</button>
      </div>
    </div>
    <div class="container mt-5" v-if="isVisible">
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <!-- 3. MODIFICADO: Escondemos este bloco no hscodes porque a validação é por ID, não por SKU -->
        <div class="accordion-item" v-if="typeImport !== 'hscodes'">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseOne"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseOne"
            >
              <span :style="styleSpan(errorSkus.length)">SKU's not found</span>
              <i
                class="fas fa-exclamation-circle text-danger"
                v-if="errorSkus.length != 0"
              ></i>
              <span v-if="errorSkus.length != 0" class="errornumber"
                >({{ errorSkus.length }})</span
              >
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseOne"
            class="accordion-collapse collapse"
          >
            <div class="accordion-body">
              <div class="row">
                <div
                  class="col-md-6"
                  v-for="(item, index) in errorSkus"
                  :key="index"
                >
                  <li>
                    <b>{{ item.sku }}</b> - {{ item.price }} -
                    {{ item.final_date }}
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseTwo"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseTwo"
            >
              <span
                v-if="typeImport == 'prices'"
                :style="styleSpan(errorUpdate.length)"
                >Error update price</span
              >
              <span
                v-if="typeImport == 'names'"
                :style="styleSpan(errorUpdate.length)"
                >Error update name</span
              >
              <!-- 4. ADICIONADO: Título do erro para HS Code -->
              <span
                v-if="typeImport == 'hscodes'"
                :style="styleSpan(errorUpdate.length)"
                >Error update HS Code</span
              >

              <i
                class="fas fa-exclamation-circle text-danger"
                v-if="errorUpdate.length != 0"
              ></i>
              <span v-if="errorUpdate.length != 0" class="errornumber"
                >({{ errorUpdate.length }})</span
              >
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseTwo"
            class="accordion-collapse collapse"
          >
            <div class="accordion-body">
              <div class="row">
                <div
                  class="col-md-6"
                  v-for="(item, index) in errorUpdate"
                  :key="index"
                >
                  <li>
                    <!-- 5. MODIFICADO: Exibição diferenciada se for erro de HS Code (mostra ID e HSCode em vez de SKU) -->
                    <template v-if="typeImport == 'hscodes'">
                      <b>ID: {{ item.id_backoffice }}</b> - HS Code:
                      {{ item.hscode }}
                      <span v-if="item.error" class="text-danger">
                        ({{ item.error }})</span
                      >
                    </template>
                    <template v-else>
                      <b>{{ item.sku }}</b> - {{ item.price }} -
                      {{ item.final_date }}
                    </template>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item" v-if="typeImport == 'prices'">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseThree"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseThree"
            >
              <span :style="styleSpan(errorLimit.length)"
                >Error in price deadline</span
              >
              <i
                class="fas fa-exclamation-circle text-danger"
                v-if="errorLimit.length != 0"
              ></i>
              <span v-if="errorLimit.length != 0" class="errornumber"
                >({{ errorLimit.length }})</span
              >
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseThree"
            class="accordion-collapse collapse"
          >
            <div class="accordion-body">
              <div class="row">
                <div
                  class="col-md-6"
                  v-for="(item, index) in errorLimit"
                  :key="index"
                >
                  <li>
                    <b>{{ item.sku }}</b> - {{ item.price }} -
                    {{ item.final_date }}
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-5">
      <b-table :items="imports">
        <template #cell(object_id)="data">
          <a
            class="downloadImported"
            @click="openFileImported(data.item.object_id)"
            >{{ data.item.object_id }}</a
          >
        </template></b-table
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from '@/components/Loading.vue';
export default {
  components: {
    Loading,
  },
  data: function () {
    return {
      file: '',
      fileName: 'Choose a file...',
      fileType: '',
      errorSkus: [],
      errorUpdate: [],
      errorLimit: [],
      isVisible: false,
      loading: false,
      imports: [],
      template: [],
      typeImport: '',
    };
  },
  methods: {
    async onFileChange() {
      this.file = this.$refs.file.files[0];
      console.log('Ficheiro: ', this.file);
      this.fileName = this.file.name;
      this.fileType = this.file.type;
    },
    async sendFile() {
      if (this.file == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Please select a file',
        });
        return;
      }
      if (this.fileType != 'text/csv') {
        this.$swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Please select a CSV file',
        });
        return;
      }
      try {
        this.loading = true;
        await this.$store.dispatch('insertFileCSV', {
          file: this.file,
          type: this.typeImport,
        });
        this.errorSkus = this.getErrorSKUS;
        this.errorUpdate = this.getErrorUpdate;
        this.errorLimit =
          this.getErrorLimit === undefined ? [] : this.getErrorLimit;
        if (
          this.errorSkus.length != 0 ||
          this.errorUpdate.length != 0 ||
          this.errorLimit.length != 0
        ) {
          this.isVisible = true;
        }
        this.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'File imported successfully',
        });
        await this.allImports();
      } catch (e) {
        alert(e);
      } finally {
        this.loading = false;
      }
    },
    styleSpan(length) {
      if (length != 0) {
        return 'font-weight: bold;';
      }
    },
    async allImports() {
      try {
        this.loading = true;
        await this.$store.dispatch('allImports');
        this.imports = this.getAllImportFiles;
      } catch (e) {
        alert(e);
      } finally {
        this.loading = false;
      }
    },
    async downloadTemplate() {
      try {
        await this.$store.dispatch('downloadImports', {
          type: this.typeImport,
        });
        this.template = this.getImportTemplates;
      } catch (e) {
        alert(e);
      }
    },
    async openFileImported(fileName) {
      try {
        await this.$store.dispatch('getFileImported', {
          fileName: fileName,
        });
      } catch (e) {
        alert(e);
      }
    },
  },
  computed: {
    ...mapGetters(['getErrorSKUS']),
    ...mapGetters(['getErrorUpdate']),
    ...mapGetters(['getErrorLimit']),
    ...mapGetters(['getAllImportFiles']),
    ...mapGetters(['getImportTemplates']),
  },
  async created() {
    await this.allImports();
  },
};
</script>

<style scoped>
.errornumber {
  font-size: 12px;
  font-weight: bold;
}
i {
  margin: 0px 5px;
}
i .text-danger {
  font-size: 20px;
}
.fa-info {
  color: #343a40;
}
small {
  color: #6c757d;
}
.template {
  text-decoration: underline;
  color: #6c757d;
}
.template:hover {
  cursor: pointer;
  color: #343a40;
}
.downloadImported {
  text-decoration: underline;
}
.downloadImported:hover {
  cursor: pointer;
  color: #343a40;
}
</style>
